<template>
	<div id="plangraduate">
		<HrrBreadcrumb PMname="岗位计划管理" CMname="高校毕业生岗位管理" />
		<HrrDetailLayout>
			<template slot="head" >
				{{title}}
			</template>
			<template slot="Form" >
                <el-form status-icon :model="form" ref="form" :rules="rules" label-width="100px" class="el-form-module" :hide-required-asterisk="isView" >
                    <el-form-item label="计划：" prop="planId">
                        <el-select v-model="form.planId" placeholder="请选择" v-if="isAdd||isEdit" >
                            <el-option
                                v-for="item in planIdData"
                                :key="item.planId"
                                :label="item.planName"
                                :value="item.planId">
                            </el-option>
                        </el-select>
                        <span v-if="isView">
                            {{form.planName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="部门：" prop="orgId">
                        <el-select v-model="form.orgId" placeholder="请选择" filterable v-if="isAdd||isEdit" >
                            <el-option
                                v-for="item in orgIdData"
                                :key="item.orgId"
                                :label="item.orgName"
                                :value="item.orgId"
                                :disabled="item.disabled">
                                <span >{{item.s+item.orgName}}</span>
                            </el-option>
                        </el-select>
                        <span v-if="isView">
                            {{form.orgName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="岗位名称：" prop="postTitle">
                        <el-input v-model="form.postTitle" v-if="isAdd||isEdit" ></el-input>
                        <span v-if="isView">
                            {{form.postTitle}}
                        </span>
                    </el-form-item>
                    <el-form-item label="岗位类型：" prop="raType">
                        <el-select v-model="form.raType" placeholder="请选择" v-if="isAdd||isEdit" >
                            <el-option
                                v-for="item in raTypeData"
                                :key="item.typeValue"
                                :label="item.typeName"
                                :value="item.typeValue">
                            </el-option>
                        </el-select>
                        <span v-if="isView">
                            {{form.raType}}
                        </span>
                    </el-form-item>
                    <el-form-item label="岗位简介：" prop="postInfo">
                        <el-input v-model="form.postInfo" v-if="isAdd||isEdit"  type="textarea" :row="3"></el-input>
                        <span v-if="isView">
                            {{form.postInfo}}
                        </span>
                    </el-form-item>
                    <el-form-item label="招聘人数：" prop="needNum">
                        <el-input-number v-model="form.needNum" controls-position="right" :min="1" v-if="isAdd||isEdit" ></el-input-number>
                        <span v-if="isView">
                            {{form.needNum}}
                        </span>
                    </el-form-item>
                    <el-form-item label="专业：" prop="major">
                        <el-input v-model="form.major" v-if="isAdd||isEdit" ></el-input>
                        <span v-if="isView">
                            {{form.major}}
                        </span>
                    </el-form-item>
                    <el-form-item label="学历要求：" prop="educationType" >
                        <el-select v-model="form.educationType" placeholder="请选择" v-if="isAdd||isEdit" >
                            <el-option
                                v-for="item in educationData"
                                :key="item.typeValue"
                                :label="item.typeName"
                                :value="item.typeValue">
                            </el-option>
                        </el-select>
                        <span v-if="isView">
                            {{form.eucationTypeName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="学位要求：" prop="diplomaType" >
                        <el-select v-model="form.diplomaType" placeholder="请选择" v-if="isAdd||isEdit" >
                            <el-option
                                v-for="item in diplomaData"
                                :key="item.typeValue"
                                :label="item.typeName"
                                :value="item.typeValue">
                            </el-option>
                        </el-select>
                        <span v-if="isView">
                            {{form.diplomaTypeName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="政治面貌：" prop="politicalType" >
                        <el-select v-model="form.politicalType" placeholder="请选择" v-if="isAdd||isEdit" >
                            <el-option
                                v-for="item in politicalTypeData"
                                :key="item.typeValue"
                                :label="item.typeName"
                                :value="item.typeValue">
                            </el-option>
                        </el-select>
                        <span v-if="isView">
                            {{form.politicalType}}
                        </span>
                    </el-form-item>
                    <el-form-item label="是否组织专业考试："  prop="gIsProfessional" label-width="160px" v-if="isAdd||isEdit">
                        <el-radio-group v-model="form.gIsProfessional">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                          </el-radio-group>
                        <span v-if="isView">
                           {{form.gIsProfessional==true?"是":"否"}}
                        </span>
                    </el-form-item>
                    <el-form-item label="考察方式：" prop="gReviewType">
                        <el-radio-group v-model="form.gReviewType" v-if="isAdd||isEdit">
                            <el-radio v-for="item in gReviewData" :label="item.typeValue" >{{item.typeName}}</el-radio>
                          </el-radio-group>
                        <span v-if="isView">
                           {{form.gReviewType}}
                        </span>
                    </el-form-item>
                    <el-form-item label="生源要求：" prop="gSourceType">
                        <el-radio-group v-model="form.gSourceType" v-if="isAdd||isEdit">
                            <el-radio v-for="item in gSourceTypeData" :label="item.typeValue">{{item.typeName}}</el-radio>
                          </el-radio-group>
                        <span v-if="isView">
                           {{form.gSourceType}}
                        </span>
                    </el-form-item>
                    <el-form-item label="计划录用人数与笔试人选的确定比例：" prop="gWrittenProportion" label-width="260px">
                        <el-input v-model="form.gWrittenProportion" v-if="isAdd||isEdit" ></el-input>
                        <span v-if="isView">
                            {{form.gWrittenProportion}}
                        </span>
                    </el-form-item>
                    <el-form-item label="计划录用人数与面试人选的确定比例：" prop="gInterviewProportion" label-width="260px">
                        <el-input v-model="form.gInterviewProportion" v-if="isAdd||isEdit" ></el-input>
                        <span v-if="isView">
                            {{form.gInterviewProportion}}
                        </span>
                    </el-form-item>
                    <el-form-item label="其他条件：" prop="other">
                        <el-input v-model="form.other" v-if="isAdd||isEdit" type="textarea" :row="3"></el-input>
                        <span v-if="isView">
                            {{form.other}}
                        </span>
                    </el-form-item>
                    <el-form-item label="招聘时间：" class="el-form-item-expiry" >
                        <span v-if="isAdd||isEdit" >
                            <el-date-picker v-model="form.expiryStartDate" placeholder="招聘起始时间" value-format="yyyy-MM-dd HH:mm:ss" type="date"></el-date-picker>
                            <span>-</span>
                            <el-date-picker v-model="form.expiryEndDate" placeholder="招聘终止时间" value-format="yyyy-MM-dd HH:mm:ss" type="date"></el-date-picker>
                        </span>
                        <span v-if="isView">
                            {{(form.expiryStartDate==null?"":form.expiryStartDate.split(" ")[0])+" 至 "+(form.expiryEndDate==null?"":form.expiryEndDate.split(" ")[0])}}
                        </span>
                    </el-form-item>
                    <el-form-item label="时间说明：" prop="oTimeDesc" >
                        <el-input v-model="form.oTimeDesc" v-if="isAdd||isEdit" ></el-input>
                        <span v-if="isView">
                            {{form.oTimeDesc}}
                        </span>
                    </el-form-item>
                    <el-form-item label="备注：" prop="remark">
                        <el-input v-model="form.remark" v-if="isAdd||isEdit" type="textarea" :row="4" ></el-input>
                        <span v-if="isView">
                            {{form.remark}}
                        </span>
                    </el-form-item>
                    <el-form-item label="状态：" prop="status" v-if="isView">
                        {{form.statusName}}
                    </el-form-item>
                    <!--<el-form-item label="岗位发布：" prop="isPublic">
                        <el-checkbox v-model="form.isPublic" v-if="isAdd||isEdit" >发布</el-checkbox>
                        <span v-if="isView">
                            {{form.isPublic==1?"已发布":"未发布"}}
                        </span>
                    </el-form-item>-->
                </el-form>
			</template>
			<template slot="buttons" >
				<el-button type="primary" @click="submitMForm('form')" v-if="isAdd||isEdit" v-show="form.status!=20" >提 交</el-button>
				<el-button  @click="resetMForm('form')" v-if="isAdd||isEdit" >重 置</el-button>
				<el-button type="info" @click="returnMForm()" >返 回</el-button>
			</template>
		</HrrDetailLayout>
	</div>
</template>
<script>
	export default {
		name: 'plan_graduates_Detail',
		data(){
			return{
				form:{
                    planId:"",
                    orgId:"",
                    postId:0,
                    postTitle:"",
                    postType:1,
                    raType:"",
                    postInfo:"",
                    needNum:1,
                    major:"",
                    educationType:"",
                    diplomaType:"",
                    politicalType:"",
                    other:"",
                    remark:"",
                    status:0,
                    gReviewType:"",
                    gSourceType:"",
                    gWrittenProportion:"",
                    gInterviewProportion:"",
                    gIsProfessional:"",
                    expiryStartDate:null,
                    expiryEndDate:null,
                    isPublic:false
				},
				rules:{
                    planId:[ { required: true, message: '请选择计划' , trigger: 'blur'}],
                    orgId:[ { required: true, message: '请选择部门' , trigger: 'blur'}],
                    postTitle:[ { required: true, message: '请填写岗位名称' , trigger: 'blur'}],
					needNum:[ { required: true, message: '请输入招聘人数' , trigger: 'blur'}],
                    raType:[ { required: true, message: '请选择科辅类型' , trigger: 'blur'}],
					major:[ { required: true, message: '请输入专业' , trigger: 'blur'}],
                    educationType:[ { required: true, message: '请选择学历要求' , trigger: 'blur'}],
                    diplomaType:[ { required: true, message: '请选择学位要求' , trigger: 'blur'}],
                    politicalType:[ { required: true, message: '请输入政治面貌' , trigger: 'blur'}],
                    gWrittenProportion:[ { required: true, message: '请输入计划录用人数与笔试人选的确定比例' , trigger: 'blur'}],
                    gInterviewProportion:[ { required: true, message: '请输入计划录用人数与面试人选的确定比例' , trigger: 'blur'}],
                    gIsProfessional:[ { required: true, message: '请选择是否组织专业考试' , trigger: 'blur'}],
                    gReviewType:[ { required: true, message: '请选择考察方式' , trigger: 'blur'}],
                    gSourceType:[ { required: true, message: '请选择生源要求' , trigger: 'blur'}]
				},
				title:"",
				isEdit:true,
                isAdd:false,
                isView:false,
                planIdData:[],
                orgIdData:[],
                educationData:[],
                diplomaData:[],
                raTypeData:[],
                politicalTypeData:[],
				reviewType:[],
                gReviewData:[],
                gSourceTypeData:[]
			}
		},
		methods:{
			submitMForm:function(formName){
                this.$refs[formName].validate((valid) =>{
                    if (valid) {
                        var loading = this.$loading({
                            lock: true,
                            text: '提交中...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        var Vuethis=this;
                        var apiUrl=(this.isAdd==true)?this.$api.plan.postAdd:this.$api.plan.postmodify;
                        this.$hrraxios.post(apiUrl,this.form)
                        .then(function(response){
                            loading.close();
                            var data=response.data;
                            if(data.success==true)
                            {
                                Vuethis.$alert("提交成功！",{callback:action=>{
                                    Vuethis.$router.push({path:'/plan/graduates/'});
                                }});
                            }else{
                                Vuethis.$message({message:data.prompt,type:"error"});
                            }
                        }).catch(function(error){
                            loading.close();
                            console.log(error);
                        })
                    } else {
                        return false;
                    }
                });
            },
			resetMForm:function(formName) {
				this.$refs[formName].resetFields();
			},
			returnMForm:function(){
				this.$router.go(-1);
			},
			initData:function(){
                this.isView=false;
                this.isEdit=false;
                this.isAdd=false;
                var Hrrtype=this.$route.params.type; //类型
                var row=this.$route.meta.row;
                var info="高校毕业生岗位";
                if(Hrrtype!="add"){
                    this.form=row;
                    this.$route.meta.row=null;
                }
                if(Hrrtype=="view"){
                    this.title="查看"+info;
                    this.isView=true;
                }
                if(Hrrtype=="edit"){
                    this.title="编辑"+info;
                    this.isEdit=true;

                }
                if(Hrrtype=="add"){
                    this.title="新增"+info;
                    this.isAdd=true;
                }
			},
            initParamsData(){
                this.$common.getplanlist(this,"planIdData");
                this.$common.getOrganizationTree(this,this.orgIdData);
                this.$common.getType({typeFortable:"Hrr_post",typeForfield:"Education_Type"},"educationData",this);
                this.$common.getType({typeFortable:"Hrr_post",typeForfield:"Diploma_Type"},"diplomaData",this);
                this.$common.getType({typeFortable:"Hrr_post",typeForfield:"G_Source_Type"},"gSourceTypeData",this);
                this.$common.getType({typeFortable:"Hrr_post",typeForfield:"RA_Type"},"raTypeData",this);
                this.$common.getType({typeFortable:"Hrr_post",typeForfield:"Political_Type"},"politicalTypeData",this);
                this.$common.getType({typeFortable:"Hrr_post",typeForfield:"G_Review_Type"},"gReviewData",this);

            }
		},
		created:function(){
			this.initData();
            this.initParamsData();
		}
	}
</script>
<style scoped>
.el-form-module{width:500px;}
</style>
